<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[960px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">สร้างทรัพยากร</span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="max-h-[642px] overflow-auto">
            <div
              class="flex flex-col sm:flex-row items-center sm:items-start justify-center gap-[30px] p-[20px]"
            >
              <!-- upload image -->
              <UploadImage v-model:image="form.image" imageDefault="resource" />
              <!-- upload image -->

              <div class="w-full grid gap-4">
                <Input
                  label="ชื่อทรัพยากร"
                  placeholder="ชื่อทรัพยากร"
                  v-model="form.name"
                  :warningMessage="errors.name"
                />
                <div class="w-full flex flex-col gap-[8px]">
                  <div class="flex items-center justify-between">
                    <div class="label">ลักษณนาม (ไม่บังคับ)</div>
                    <div
                      @click="openAddClassifier"
                      class="flex items-center gap-[6px] cursor-pointer"
                    >
                      <AddIcon class="text-[#9B237B]" />
                      <span class="PC_Body2-SB text-[#9B237B]">
                        เพิ่มลักษณนาม
                      </span>
                    </div>
                  </div>
                  <SelectBoxComponent
                    :inputId="'unit_id'"
                    :searchable="true"
                    :allowEmpty="true"
                    :keyValue="'id'"
                    :keyName="'name'"
                    :options="allProductClassifier"
                    :value="form.unit_id"
                    :placeholder="'เลือกลักษณนาม'"
                    @update:modelValue="
                      (res) => {
                        form.unit_id = res;
                      }
                    "
                  />
                </div>
                <div
                  class="w-full grid grid-cols-1 sm:grid-cols-2 items-start gap-[14px]"
                >
                  <SelectBoxComponent
                    :inputId="'group_id'"
                    :keyValue="'id'"
                    :keyName="'name'"
                    :options="allProductGroup"
                    :value="form.group_id"
                    :label="'หมวดหมู่'"
                    :placeholder="'เลือกหมวดหมู่'"
                    :warningMessage="errors.group_id"
                    @update:modelValue="
                      (res) => {
                        form.group_id = res;
                      }
                    "
                  />
                  <div class="flex flex-col gap-[8px]">
                    <div class="flex items-center justify-between">
                      <div class="label">ประเภท (ไม่บังคับ)</div>
                      <div
                        @click="openAddType"
                        class="flex items-center gap-[6px] cursor-pointer"
                      >
                        <AddIcon class="text-[#9B237B]" />
                        <span class="PC_Body2-SB text-[#9B237B]">
                          เพิ่มประเภท
                        </span>
                      </div>
                    </div>
                    <SelectBoxComponent
                      :inputId="'category_id'"
                      :searchable="true"
                      :allowEmpty="true"
                      :keyValue="'id'"
                      :keyName="'name'"
                      :options="allProductType"
                      :value="form.category_id"
                      :placeholder="'เลือกประเภท'"
                      @update:modelValue="
                        (res) => {
                          form.category_id = res;
                        }
                      "
                    />
                  </div>
                </div>
                <Input
                  label="แหล่งที่มา (ไม่บังคับ)"
                  placeholder="แหล่งที่มา"
                  v-model="form.source"
                  :warningMessage="errors.source"
                />
                <Input
                  label="รายละเอียด (ไม่บังคับ)"
                  placeholder="รายละเอียด"
                  v-model="form.detail"
                  :warningMessage="errors.detail"
                />
                <div class="flex justify-end items-center gap-[10px]">
                  <ButtonComponent
                    :label="'บันทึก'"
                    :bClass="'btn_shadow--onlySave'"
                    :disabled="form.name == '' || form.group_id == ''"
                    @clicked="save"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";

const { $validateMsg, $buildFormData } = useGlobals();
const productStore = useProductStore();
const { allProductType, allProductClassifier, allProductGroup } =
  storeToRefs(productStore);
const input = {
  name: "",
  category_id: "",
  source: "",
  detail: "",
  unit_id: "",
  unit_type: 2,
  group_id: "",
  quantity: "",
  image: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const modalIsOpened = ref(false);

const emit = defineEmits([
  "status",
  "open",
  "openAddType",
  "openAddClassifier",
]);

const openModal = () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  form.value = {
    ...input,
    unit_type: 2,
    quantity: 0,
  };
  errors.value = {
    ...input,
  };
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const openAddType = () => {
  emit("openAddType");
};

const openAddClassifier = () => {
  emit("openAddClassifier");
};

const save = async () => {
  let formData = new FormData();
  const data0 = $buildFormData(formData, form.value);
  await productStore
    .createProduct(data0)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("open", response.data.data);
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.label,
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
</style>